module.exports = __webpack_public_path__ + "assets/img/2b6517f7dd0b38c8fa2630c389724686.png";